// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import IconButtonWrapper from "metabase/common/components/IconButtonWrapper";
import LoadingSpinner from "metabase/common/components/LoadingSpinner";
import { color } from "metabase/ui/utils/colors";

type StatusVariant = "warning" | "error";

interface StatusVariantProps {
  variant?: StatusVariant;
}

export const StatusRoot = styled.div<StatusVariantProps>`
  width: ${(props) => (props.variant ? "22.5rem" : "16rem")};
  border-radius: 6px;
  background-color: var(--mb-color-bg-white);
  box-shadow: 0 1px 12px var(--mb-color-shadow);
  overflow: hidden;
  margin-top: 1rem;
`;

export const StatusHeader = styled.div<StatusVariantProps>`
  display: flex;
  align-items: center;
  padding: 0.625rem 1rem;
  background-color: ${(props) =>
    props.variant
      ? `var(--mb-color-${props.variant})`
      : "var(--mb-color-brand)"};
`;

export const StatusTitle = styled.div<StatusVariantProps>`
  flex: 1 1 auto;
  width: 100%;
  color: ${(props) =>
    props.variant === "warning"
      ? "var(--mb-color-text-dark)"
      : "var(--mb-color-bg-light)"};
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1rem;
`;

export const StatusToggle = styled(IconButtonWrapper, {
  shouldForwardProp: (prop) => prop !== "variant",
})<StatusVariantProps>`
  flex: 0 0 auto;
  color: ${(props) =>
    props.variant === "warning"
      ? "var(--mb-color-text-dark)"
      : "var(--mb-color-text-white)"};
`;

export const StatusBody = styled.div`
  background-color: var(--mb-color-bg-white);
`;

interface StatusCardRootProps {
  hasBody?: boolean;
  variant?: StatusVariant;
}

export const StatusCardRoot = styled.div<StatusCardRootProps>`
  display: flex;
  align-items: ${(props) => (props.hasBody ? "flex-start" : "center")};
  margin: 0.75rem;
  padding: ${(props) => (props.variant ? "0.75rem" : 0)};
  border: 1px solid
    ${(props) =>
      props.variant ? `var(--mb-color-${props.variant})` : "transparent"};
  border-radius: 0.5rem;
  background-color: ${(props) =>
    props.variant
      ? `var(--mb-color-background-${props.variant})`
      : "transparent"};
`;

export const StatusCardBody = styled.div<StatusVariantProps>`
  display: ${(props) => (props.variant ? "flex" : "block")};
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  margin: ${(props) => (props.variant ? 0 : "0 0.75rem")};
  overflow: hidden;
`;

export const StatusCardIcon = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  color: var(--mb-color-brand);
  background-color: var(--mb-color-brand-light);
`;

export const StatusCardTitle = styled.div<StatusVariantProps>`
  order: ${(props) => (props.variant ? 2 : 1)};
  color: ${(props) =>
    props.variant
      ? "var(--mb-color-text-medium)"
      : "var(--mb-color-text-dark)"};
  font-size: ${(props) => (props.variant ? "0.75rem" : "0.875rem")};
  font-weight: ${(props) => (props.variant ? "normal" : "bold")};
  line-height: 1rem;
  margin-top: ${(props) => (props.variant ? "0.5rem" : 0)};
  overflow: hidden;
`;

export const StatusCardDescription = styled.div<{ variant?: StatusVariant }>`
  order: 1;
  color: ${(props) =>
    props.variant === "error"
      ? "var(--mb-color-error)"
      : "var(--mb-color-text-dark)"};
  font-size: ${(props) => (props.variant ? "0.875rem" : "0.6875rem")};
  font-weight: bold;
  line-height: ${(props) => (props.variant ? "1.25rem" : "0.8125rem")};
  margin-top: 0.25rem;
`;

export const StatusCardSpinner = styled(LoadingSpinner)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mb-color-brand);
`;

interface StatusCardIconContainerProps {
  variant?: StatusVariant;
}

export const StatusCardIconContainer = styled.div<StatusCardIconContainerProps>`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 1rem;
  color: ${(props) =>
    props.variant === "warning"
      ? "var(--mb-color-text-dark)"
      : "var(--mb-color-text-white)"};
  background-color: ${(props) =>
    props.variant ? color(props.variant) : color("success")};
`;
